import { type AnyAction, type ReducersMapObject } from "@reduxjs/toolkit";
import { type ICommonsStore } from "commons";
import { combineReducers } from "redux";
import layers from "commons/layers/store/layerR";
import navigates, { type INavigates } from "./navigates/navigatesR";
import notice, { type INotice } from "pages/notice/store/NoticeR";
import calculate, { type ICalculate } from "pages/calculate/store/CalculateR";
import profit, { type IProfit } from "pages/profit/store/ProfitR";
import userManage, { type IUserManage } from "pages/user/store/UserR";
import statistics, { type IStatistics } from "pages/statistics/store/StatisticsR";
import member, { type IMember } from "pages/user/member/memberR";
import cookies from "commons/cookies/cookiesR";
import auth, { type IAuth } from "./auth/authR";
import signup, { type ISignup } from "pages/signup/store/signupR";
import translate, { type ITranslate } from "pages/translation/store/TranslationR";
import user, { type IUser } from "pages/myInfo/store/myInfoR";
import consaladMapping from "pages/user/consalad/store/mappingR";
import type { IConsaladMappingState } from "pages/user/consalad/store/mappingVo";

import CommonsSlim from "commons/store/CommonsSlim";
import service, { type IService } from "pages/service/store/ServiceR";

/**
 * state interface 설정
 */
export interface IState extends ICommonsStore {
  // 로그인사용자
  user: IUser;
  // 토큰관련
  auth: IAuth;

  // 회원가입 관련
  signup: ISignup;
  // 네비게이션바
  navigates: INavigates;

  // 공지사항
  notice: INotice;

  //통계
  statistics: IStatistics;

  //수익
  profit: IProfit;

  //사용자
  member: IMember;

  //서비스
  service: IService;

  //번역
  translate: ITranslate;

  /**
   * NOTE: 사용자 관리도 insight쪽 처럼 SR.ts로 묶는게 좋아보임..
   */
  // 사용자 관리 > 뷰어스
  userManage: IUserManage;
  // 사용자 관리 > 음원/영상(콘셀러드)
  consaladMapping: IConsaladMappingState;

  // 정산관리
  calculate: ICalculate;
}

/**
 * 베이스 reducer 설정
 * @param state 상태를 담고있는 변수
 * @param action 행동에 의해 변화되는 값들
 * @returns
 */

const defaultReducers = {
  ...CommonsSlim({ layers, auth, cookies }),
  user,
  notice,
  navigates,
  userManage,
  member,
  calculate,
  consaladMapping,
  statistics,
  profit,
  service,
  signup,
  translate,
};

// 리턴 타입이 무었인지 확인하여야 함
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const rootReducer = (state: IState | undefined, action: AnyAction) => {
  const switchGradeReducers = () => {
    return { ...defaultReducers };
  };
  switch (action.type) {
    default:
      return combineReducers(switchGradeReducers() as ReducersMapObject<IState, AnyAction>)(state, action);
  }
};

export default rootReducer;
